module.exports = __webpack_public_path__ + "static/img/craigFour.697bbc46.png";